import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import image1 from '../../assets/images/pages/article-7/1.jpg'
import image2 from '../../assets/images/pages/article-7/2.jpg'
import image3 from '../../assets/images/pages/article-7/3.jpg'
import image4 from '../../assets/images/pages/article-7/4.jpg'
import image5 from '../../assets/images/pages/article-7/5.jpg'
import { Articles } from '../../components/Article/Articles/Articles'
import { Feedback } from '../../components/Feedback/Feedback'
import { Footer } from '../../components/Footer/Footer'
import { Header } from '../../components/Header/Header'
import { BackButton } from '../../components/UI/BackButton/BackButton'
import styles from '../../pages/ArticlesPage/articlePage.module.scss'

export const ArticlePage7 = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      <Header />
      <main className={`${styles.articlePage} ${styles.article1}`}>
        <section className={styles.articleIntro}>
          <BackButton url='/' />

          <h1>
            <b>Феномен зеленого двора:</b>
            <br />
            как жизнь в&nbsp;окружении природы влияет на&nbsp;горожан
          </h1>

          <div className={styles.articleLead}>
            Мегаполисы привлекают разнообразием возможностей для карьеры,
            образования и&nbsp;развлечений. Но&nbsp;когда дело доходит
            до&nbsp;выбора жилья, люди часто ищут проекты поблизости
            от&nbsp;природных оазисов. Разбираемся, почему горожан так тянет
            жить в&nbsp;окружении флоры и&nbsp;фауны и&nbsp;чем полезен человеку
            постоянный контакт с&nbsp;природой
          </div>

          <div className={styles.articleDescrImg}>
            <img src={image1} alt={''} />
          </div>
        </section>
        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            Как природа притягивает
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Зеленые массивы неподалеку от&nbsp;жилого комплекса&nbsp;&mdash;
                один из&nbsp;значимых факторов для выбора квартиры. Более трети
                россиян обращают внимание на&nbsp;близость озелененных
                территорий при покупке жилья в&nbsp;новостройке,{' '}
                <a
                  href='https://realty.rbc.ru/news/6389b3b69a794751fef1941d'
                  target='_blank'
                >
                  следует
                </a>{' '}
                из&nbsp;опроса портала &laquo;Единый ресурс застройщиков&raquo;.
                Такая тенденция характерна не&nbsp;только для России.
                &laquo;В&nbsp;разных странах проводились исследования, изучающие
                предпочтения по&nbsp;благоустройству желаемого жилья. Решающим
                фактором при выборе являлось наличие зеленых зон в&nbsp;близком
                доступе&raquo;,&nbsp;&mdash; рассказала эколог и&nbsp;научный
                сотрудник Института социологии РАН Юлия Ермолаева.
              </p>
              <p>
                Значимость природного окружения для покупателей квартир
                подтверждает тезис о&nbsp;том, что люди интуитивно стремятся
                к&nbsp;жизни ближе к&nbsp;естественной среде. &laquo;Желание
                человека жить рядом с&nbsp;зеленой зоной продиктовано
                инстинктами,&nbsp;&mdash; объясняет Ирина Головачева,
                клинический психолог и&nbsp;заместитель директора института
                экологии РУДН. &mdash;&nbsp;Когда мы&nbsp;выбираем место для
                жилья, а&nbsp;значит, и&nbsp;для выращивания потомства,
                мы&nbsp;инстинктивно стремимся к&nbsp;той среде, которая нам
                хорошо знакома, безопасна и&nbsp;чаще продиктована генетической
                памятью. Поэтому человек всегда будет стремиться
                к&nbsp;естественным природным ландшафтам&raquo;.
              </p>
              <p>
                По&nbsp;словам клинического психолога, гештальт-терапевта
                и&nbsp;психоаналитика Ирины Смолярчук, ощущать притяжение
                природы особенно характерно для взрослых людей.
                &laquo;Густонаселенные крупные промышленные города открывают
                человеку возможности для самореализации,
                но&nbsp;в&nbsp;то&nbsp;же время отнимают его
                аутентичность,&nbsp;&mdash; считает Смолярчук. &mdash;&nbsp;Ритм
                городской жизни и&nbsp;карьерные марафоны выматывают, поэтому
                люди, достигшие карьерных амбиций, снова и&nbsp;снова
                возвращаются на&nbsp;лоно природы. Сначала они стремятся выехать
                из&nbsp;города на&nbsp;выходные: на&nbsp;природу,
                на&nbsp;шашлыки или на&nbsp;рыбалку. К&nbsp;зрелости тяга
                к&nbsp;природе усиливается, потому что только естественные
                ресурсы помогают восстановиться в&nbsp;ментальном, психическом
                и&nbsp;физическом здоровье, найти равновесие&raquo;.
              </p>
            </div>
          </div>

          <div className={styles.articleDescrImg}>
            <img src={image2} alt={''} />
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            Как природа оздоравливает
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Исследователи из&nbsp;разных стран регулярно публикуют работы,
                доказывающие позитивный эффект от&nbsp;пребывания
                в&nbsp;естественной среде для психического и&nbsp;физического
                здоровья. &laquo;Созерцание природного пейзажа помогает
                уменьшить активность симпатической нервной системы,
                ответственной за&nbsp;триггер стрессовых реакций, положительно
                воздействует на&nbsp;зрительные и&nbsp;слуховые сенсоры,
                когнитивные функции. У&nbsp;человека, который больше времени
                проводит в&nbsp;зеленых и&nbsp;голубых (водных) зонах,
                нормализуется уровень кислорода в&nbsp;крови и&nbsp;давление.
                Более активная деятельность&nbsp;&mdash; прогулки в&nbsp;зеленых
                парках, походы в&nbsp;горы, тренировки на&nbsp;свежем
                воздухе&nbsp;&mdash; могут способствовать высвобождению
                эндорфинов&raquo;,&nbsp;&mdash; рассказала Юлия Ермолаева
                со&nbsp;{' '}
                <a
                  href='https://pubmed.ncbi.nlm.nih.gov/36520498/#full-view-affiliation-1'
                  target='_blank'
                >
                  ссылкой
                </a>{' '}
                на&nbsp;исследование ученых из&nbsp;лондонского Имперского
                колледжа.
              </p>
              <p>
                О&nbsp;важности прогулок на&nbsp;природе для ментального
                здоровья говорит и&nbsp;Ирина Смолярчук: &laquo;Пешая прогулка
                на&nbsp;свежем воздухе в&nbsp;лесу помогает избавиться
                от&nbsp;лишнего напряжения, накопленного на&nbsp;фоне городской
                суеты. В&nbsp;организме живых существ накапливается гормон
                стресса кортизол, который вызывает ощущение опустошенности или
                даже депрессивные расстройства. Лучший способ избавиться
                от&nbsp;избытка этого гормона&nbsp;&mdash; прогулка
                на&nbsp;свежем воздухе или спортивная нагрузка&raquo;.
              </p>
              <p>
                В&nbsp;окружении растительности городской человек чувствует себя
                более умиротворенно и&nbsp;спокойно, отмечает доцент института
                экологии РУДН и&nbsp;кандидат экономических наук Владимир
                Пинаев. &laquo;При выборе жилья важно, чтобы рядом были зоны
                рекреации&nbsp;&mdash; парки, скверы,&nbsp;&mdash; уверен
                Пинаев. &mdash;&nbsp;Чем более озеленена территория,
                на&nbsp;которой расположен дом, тем приятнее в&nbsp;нем жить.
                Также важно вспомнить о&nbsp;влиянии окружающей среды
                на&nbsp;психоэмоциональное состояние человека. Здесь
                мы&nbsp;затрагиваем вопросы видеоэкологии&raquo;.
              </p>
              <p>
                Видеоэкологией специалисты называют науку о&nbsp;взаимодействии
                человека с&nbsp;окружающей видимой средой. По&nbsp;словам Ирины
                Головачевой, наличие природных компонентов в&nbsp;визуальной
                среде благотворно влияет на&nbsp;психоэмоциональное состояние
                человека, даже если тот не&nbsp;любуется природой намеренно.
              </p>
              <p>
                &laquo;Влияние визуальной среды на&nbsp;психоэмоциональное
                состояние можно сравнить с&nbsp;нахождением в&nbsp;открытом
                океане,&nbsp;&mdash; рассуждает Ирина Головачева.
                &mdash;&nbsp;Когда мы&nbsp;находимся в&nbsp;гомогенной среде,
                где не&nbsp;хватает видимых элементов, организм ощущает себя
                так, будто его выбросили в&nbsp;открытый океан и&nbsp;рядом нет
                ничего, за&nbsp;что можно ухватиться, никакой опоры.
                Накапливается усталость, ощущение безысходности, дискомфорта
                и&nbsp;неопределенности. Когда мы&nbsp;в&nbsp;агрессивной
                визуальной среде, где повторяющиеся фигуры представлены
                в&nbsp;изобилии, это ощущается будто вы&nbsp;в&nbsp;океане
                и&nbsp;рядом полно плавающих, но&nbsp;неустойчивых предметов,
                за&nbsp;которые уцепиться не&nbsp;получается, они еще больше
                топят. Соответственно, мы&nbsp;ощущаем панику, некое угнетение.
                А&nbsp;когда визуальная среда комфортная, с&nbsp;наличием
                естественного ландшафта, красивых и&nbsp;приятных объектов,
                разных узоров и&nbsp;красок, мы&nbsp;ощущаем себя
                в&nbsp;безопасности, более спокойно. Это тот&nbsp;же океан,
                но&nbsp;мы&nbsp;в&nbsp;спасательном кругу или уцепились
                за&nbsp;добротный плот&raquo;.
              </p>
              <p>
                Время на&nbsp;природе помогает не&nbsp;только избавиться
                от&nbsp;эмоционального перенапряжения, но&nbsp;и&nbsp;защитить
                себя от&nbsp;тяжелых болезней в&nbsp;будущем. Большой срез
                научных данных{' '}
                <a
                  href='https://www.ucl.ac.uk/news/2022/dec/green-social-prescribing-time-nature-can-increase-wellbeing'
                  target='_blank'
                >
                  представили
                </a>{' '}
                в&nbsp;прошлом году ученые Университетского колледжа Лондона.
                В&nbsp;их&nbsp;отчетах говорится, что контакт с&nbsp;природой
                может снижать риск сердечно-сосудистых и&nbsp;респираторных
                заболеваний, диабета, ожирения. Удивительно, но&nbsp;лес
                за&nbsp;окном может даже продлевать жизнь&nbsp;&mdash;
                исследователи нашли прочную связь между зелеными пространствами
                у&nbsp;дома и&nbsp;снижением показателей смертности
                от&nbsp;любых причин.
              </p>
              <p>
                Кажется, что в&nbsp;условиях мегаполиса найти недвижимость
                поблизости от&nbsp;большого лесного массива практически
                невозможно. Однако несколько современных проектов доказывают
                обратное. Например, в&nbsp;Новой Москве возводится жилой
                комплекс &laquo;Середневский лес&raquo;, в&nbsp;10&nbsp;минутах
                пешком от&nbsp;которого расположилась огромная зеленая зона
                Валуевского лесопарка. Будущие жители комплекса оценят
                первозданность местного леса: в&nbsp;нем нет ровных мощеных
                дорожек, зато есть множество елей, лип, ручьев и&nbsp;заводей.
                Бродя по&nbsp;лесу, можно послушать, как стучит дятел, встретить
                белку или зайца.
              </p>
              <p>
                В&nbsp;Старой Москве строится жилой квартал &laquo;Академика
                Павлова&raquo;: он&nbsp;появится в&nbsp;экологически чистом
                районе Кунцево, новый проект с&nbsp;трех сторон будут окружать
                большие зеленые зоны. Ближе всего к&nbsp;комплексу расположился
                природно-исторический парк &laquo;Москворецкий&raquo;,
                объединяющий благоустроенные территории Крылатских Холмов,
                Суворовского парка и&nbsp;парка &laquo;Фили&raquo;.
                Вариативность парков позволит каждый день устраивать моцион
                в&nbsp;новом месте. Важно, что за&nbsp;такую близость
                к&nbsp;природе не&nbsp;придется расплачиваться долгой дорогой
                на&nbsp;работу: от&nbsp;домов &laquo;Академика Павлова&raquo;
                до&nbsp;станции метро &laquo;Молодежная&raquo;&nbsp;&mdash;
                всего семь минут пешком.
              </p>
            </div>
          </div>
          <div className={styles.articleDescrImg}>
            <img src={image3} alt={''} />
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>Как природа объединяет</h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Зачастую выезд из&nbsp;города на&nbsp;природу воспринимается как
                возможность сбежать подальше от&nbsp;городского шума
                и&nbsp;насладиться уединением. При этом именно природа помогает
                выстраивать здоровые связи с&nbsp;окружающими, влияет
                на&nbsp;поведение и&nbsp;развивает способность
                к&nbsp;сопереживанию. Это доказали ученые
                из&nbsp;Калифорнийского университета, которые{' '}
                <a
                  href='https://www.sciencedirect.com/science/article/abs/pii/S2352250X19300594?via%3Dihub'
                  target='_blank'
                >
                  выяснили:
                </a>{' '}
                пребывание в&nbsp;естественном окружении связано
                с&nbsp;просоциальным поведением&nbsp;&mdash; повышенным
                вниманием к&nbsp;потребностям окружающих, стремлением сплотиться
                с&nbsp;теми, к&nbsp;живет по&nbsp;соседству.
              </p>
              <p>
                &laquo;Между частотой социальных коммуникаций и&nbsp;озеленением
                найдены корреляции,&nbsp;&mdash; подтвердила Юлия Ермолаева.
                &mdash;&nbsp;Социальная жизнь более интенсивна в&nbsp;местах
                с&nbsp;зеленой инфраструктурой и&nbsp;голубыми зонами. Если она
                удобно обустроена и&nbsp;ухожена, она притягивает к&nbsp;себе
                людей, пространство помогает им&nbsp;заводить новые социальные
                связи. Чем лучше зеленая среда обустроена для разных категорий
                населения&nbsp;&mdash; детей, активных спортсменов, пожилых
                людей,&nbsp;&mdash; тем более ожидаемо, что ее&nbsp;будут
                посещать&raquo;.
              </p>
              <p>
                Двор с&nbsp;озеленением и&nbsp;продуманным устройством способен
                объединить жителей квартала, помочь им&nbsp;создать сплоченное
                сообщество. Однако далеко не&nbsp;каждая придомовая территория
                располагает к&nbsp;общению соседей, уверена социолог.
                По&nbsp;словам Ермолаевой, зеленый сквер у&nbsp;дома должен быть
                чист, благоустроен и&nbsp;оборудован зонами для активностей.
                Кроме того, сами жильцы должны проводить в&nbsp;нем достаточное
                количество времени, быть заинтересованы в&nbsp;жизни двора,
                разделять ответственность в&nbsp;рамках пользования
                общественными пространствами. &laquo;Чем больше люди вовлечены
                в&nbsp;жизнь сквера, тем больше они ориентированы
                на&nbsp;осознание себя как части того или иного
                сообщества&raquo;,&nbsp;&mdash; пояснила эколог.
              </p>
              <p>
                Создать сплоченный коллектив соседей будет легко жителям
                квартала &laquo;Зеленый парк&raquo; в&nbsp;Зеленограде.
                В&nbsp;комплексе обустроят дворы-парки&nbsp;&mdash; приватные
                пространства только для резидентов. Тихие и&nbsp;уютные дворы
                без машин будут утопать в&nbsp;зелени, вдохновлять
                на&nbsp;размеренный отдых и&nbsp;неспешные прогулки.
                А&nbsp;между домами протянется длинный пешеходный бульвар
                с&nbsp;игровыми площадками и&nbsp;уличными тренажерами. Здесь
                можно будет гулять с&nbsp;детьми, заниматься спортом, кататься
                на&nbsp;роликах и&nbsp;велосипедах или просто наслаждаться
                свежим воздухом. Все части придомовой территории будут
                &laquo;работать&raquo; на&nbsp;сплочение людей и&nbsp;создание
                дружного сообщества соседей.
              </p>
            </div>
          </div>

          <div className={styles.articleDescrImg}>
            <img src={image4} alt={''} />
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            Как природа воспитывает
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Особое значение время среди зелени и&nbsp;поблизости
                от&nbsp;воды имеет для правильного развития подрастающего
                поколения. Неудивительно, что именно после рождения детей жители
                мегаполисов задумываются о&nbsp;том, чтобы перебраться ближе
                к&nbsp;лесу или реке.
              </p>
              <p>
                <a
                  href='https://www.ucl.ac.uk/news/2022/dec/green-social-prescribing-time-nature-can-increase-wellbeing'
                  target='_blank'
                >
                  Доказано,
                </a>{' '}
                что игры на природе укрепляют здоровье детей, повышают их
                физическую активность и когнитивные способности. У детей,
                которые часто взаимодействуют с окружающей средой, реже
                возникают проблемы с поведением, легче проходит социальная
                адаптация. Кроме того, контакт с природой учит их с уважением и
                бережно относиться к флоре и фауне вокруг себя.
              </p>
              <p>
                &laquo;Пребывание на&nbsp;природе увеличивает вероятность того,
                что человек будет ее&nbsp;оберегать. Ранний детский опыт
                взаимодействия с&nbsp;природной средой помогает лучше понять
                биологические и&nbsp;экологические процессы, поскольку
                развивается системное мышление. А&nbsp;сама природная среда
                положительно влияет на&nbsp;физиологию, психологическое
                состояние, и, как следствие, на&nbsp;развитие сопереживания
                к&nbsp;природе&raquo;,&nbsp;&mdash; объяснила Юлия Ермолаева.
              </p>
              <p>
                При этом эксперт убеждена, что для формирования
                экологически-ориентированного поведения значим не&nbsp;только
                контакт с&nbsp;природой, но&nbsp;и&nbsp;правильное воспитание:
                &laquo;Не&nbsp;менее важно экологическое воспитание
                и&nbsp;образование, создание базиса экологических знаний,
                привычек. Ценностью должно быть не&nbsp;просто осознание
                важности сохранения чистой окружающей среды, а&nbsp;понимание,
                что это жизненная необходимость в&nbsp;современных
                реалиях&raquo;.
              </p>
              <p>
                Устроить знакомство с&nbsp;природой и&nbsp;привить детям
                уважение к&nbsp;ней поможет окружение жилого комплекса
                &laquo;Бунинские луга&raquo;. Квартал появится в&nbsp;семи
                километрах от&nbsp;МКАД, в&nbsp;живописном районе
                с&nbsp;зелеными аллеями и&nbsp;прудами. В&nbsp;пешей доступности
                от&nbsp;комплекса раскинулся уютный ландшафтный парк
                &laquo;Южное Бутово&raquo;. Здесь есть спортивные и&nbsp;детские
                площадки, велодорожки, зоны для пикников. Летом можно
                отправиться с&nbsp;детьми на&nbsp;прогулку к&nbsp;Ивановскому
                пруду, зимой&nbsp;&mdash; кататься на&nbsp;лыжах и&nbsp;санках.
              </p>
              <p>
                Однообразный отдых может легко утомить детей, поэтому родителям
                стоит выбирать кварталы, открывающие доступ к самым разным
                активностям на свежем воздухе. Например, около комплекса
                «Кузьминский лес» расположился большой Кузьминский лесопарк, где
                можно покататься на лодке или аттракционах, погулять по
                сосновому бору с экскурсией от сотрудников местного экоцентра и
                заглянуть в музей Паустовского. Еще больше разнообразия для
                отдыха у резидентов квартала «Кузьминский лес» будет благодаря
                близости усадьбы «Белая Дача» на берегу большого пруда. На
                территории расположены старинные постройки и несколько
                памятников. Насыщенную программу прогулок для всей семьи будет
                легко организовывать каждые выходные.
              </p>
            </div>
          </div>

          <div className={styles.articleDescrImg}>
            <img src={image5} alt={''} />
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>Вывод</h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Жизнь в&nbsp;контакте с&nbsp;природой всегда притягивала людей.
                Даже&nbsp;те, кто предпочли мегаполисы сельской местности,
                стремятся поселиться ближе к&nbsp;лесам, паркам и&nbsp;рекам.
                Природное окружение улучшает здоровье, повышает способность
                к&nbsp;сопереживанию, помогает общаться и&nbsp;быть внимательным
                к&nbsp;экологии. И&nbsp;хотя кажется, что для крупных городов
                природные оазисы&nbsp;&mdash; это роскошь, на&nbsp;рынке
                недвижимости встречаются редкие проекты с&nbsp;демократичным
                ценником для тех, кто хочет жить в&nbsp;естественной среде
                и&nbsp;не&nbsp;терять контакт с&nbsp;природой.
              </p>
            </div>
          </div>
        </section>

        <section className={styles.articleContent}>
          <Articles excludeId='7' />
        </section>
        <Feedback />
      </main>
      <Footer />
    </>
  )
}
